import React from "react";
import { Container } from "./styles";
import PropTypes from "prop-types";

function Button({ text, size, typeButton, func }) {
  return (
    <>
      <Container size={size} typeButton={typeButton} onClick={func}>
        {text}
      </Container>
    </>
  );
}

Button.prototype = {
  text: PropTypes.string.isRequired,
  size: PropTypes.oneOf[("big", "medium", "small")],
  typeButton: PropTypes.oneOf[("primary", "secondary")],
  func: PropTypes.func,
};

export default Button;
